import React from 'react';

export default () => (
    <address>
		G9-LLC <br/>
		35 Meeting House Rd.<br/>
		Greenwich, Connecticut 06831 <br/>
	</address>
);
